module.exports = __webpack_public_path__ + "img/unload-4-2.d47e8d77.png";